/* Exact dimensional display normalization for lighting only, including translated descriptions. */
(function (root) {
  const number = String.raw`\d+(?:[ \u00a0\u202f]\d{3})*(?:[.,]\d+)?`;
  const label = String.raw`(?:[\p{L}Øø⌀.]+[ \u00a0\u202f]*)?`;
  const dimensions = new RegExp(`(${number}(?:[ \\u00a0\\u202f]*[×xX][ \\u00a0\\u202f]*${label}${number})*)[ \\u00a0\\u202f]*(?:mm|millimètres?|millimeters?|millimetres?)\\b`, 'giu');
  const numbers = new RegExp(number, 'g');
  function centimeters(value, language) {
    const clean = value.replace(/[ \u00a0\u202f]/g, '').replace(',', '.');
    // Move the decimal point one place left: no floating-point rounding of physical values.
    const parts = clean.split('.');
    const integer = parts[0];
    const whole = (integer.slice(0, -1) || '0').replace(/^0+(?=\d)/, '');
    const fraction = (integer.slice(-1) + (parts[1] || '')).replace(/0+$/, '');
    return whole + (fraction ? (language.startsWith('fr') ? ',' : '.') + fraction : '');
  }
  function convertLightingDimensions(text, language = 'fr') {
    return text.replace(dimensions, (_, expression) => expression.replace(numbers, value => centimeters(value, language)) + ' cm');
  }
  function normalize(container) {
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (const node of nodes) {
      if (node.parentElement?.closest('script, style, svg, textarea, input')) continue;
      const next = convertLightingDimensions(node.nodeValue, document.documentElement.lang || 'fr');
      if (next !== node.nodeValue) node.nodeValue = next;
    }
  }
  function mount() {
    document.querySelectorAll('[data-lighting-cm]').forEach(normalize);
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { convertLightingDimensions };
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
    else mount();
    document.addEventListener('shopify:section:load', mount);
  }
})(typeof window !== 'undefined' ? window : globalThis);
